import React, { FC, ReactNode } from 'react'
import { View, TouchableOpacity, StyleSheet } from 'react-native'
import { color, spacing, fontFamily, fontSize } from '@partipost-cm-new/app-preview/dist/Styles/Base'
import { moderateScale } from '@partipost-cm-new/app-preview/dist/Utils/Scaling'
import PartiText from '@partipost-cm-new/app-preview/dist/Components/PartiText'
import RoundCornerButton from '@partipost-cm-new/app-preview/dist/Components/RoundCornerButton'
import { useNewTranslation } from 'hooks'
import Icon from 'particles/Icon'

interface SubmitPageProps {
    buttonText?: string
    children?: ReactNode
    showBackButton?: boolean
    showNextButton?: boolean
    stepIndex?: string
    totalStepNumber?: string
}

const SubmitPage: FC<SubmitPageProps> = ({
    buttonText,
    children,
    showBackButton = false,
    showNextButton = true,
    stepIndex,
    totalStepNumber,
}) => {
    const [t] = useNewTranslation()
    return (
        <View style={{ flex: 1, justifyContent: 'space-between', height: '100%' }}>
            <View style={{ backgroundColor: color.white, flex: 1, paddingTop: (spacing.medium + spacing.small) * 2 }}>
                <TouchableOpacity
                    disabled={true}
                    style={{
                        left: moderateScale(10),
                        top: spacing.small,
                        position: 'absolute',
                        width: moderateScale(40),
                    }}
                >
                    <Icon size="24px" name={'x'} color={'neutralActionActive'} />
                </TouchableOpacity>
                <View style={{ right: spacing.medium, top: spacing.small, position: 'absolute' }}>
                    {stepIndex && totalStepNumber && (
                        <PartiText style={styles.stepLabel}>
                            {t('appCampaign.campaignStep.stepNumberOfTotalStepsLabel', {
                                number: stepIndex,
                                length: totalStepNumber,
                            })}
                        </PartiText>
                    )}
                </View>
                {children}
            </View>

            <View style={{ ...styles.shadowContainer, ...styles.buttonContainer }}>
                <TouchableOpacity disabled={true} style={{ paddingVertical: spacing.small }}>
                    <View style={{ opacity: showBackButton ? 1 : 0, flexDirection: 'row', alignItems: 'center' }}>
                        <Icon size="24px" name={'caretLeft'} color={'neutralActionActive'} />
                    </View>
                </TouchableOpacity>
                <RoundCornerButton
                    disabled={true}
                    customStyle={{
                        borderRadius: spacing.small,
                        alignItems: 'center',
                        height: moderateScale(45),
                        backgroundColor: color.christine,
                        width: '70%',
                    }}
                    customText={{
                        color: color.white,
                        fontSize: moderateScale(16),
                        fontFamily: fontFamily.title,
                    }}
                >
                    {buttonText}
                </RoundCornerButton>

                <TouchableOpacity disabled={true} style={{ paddingVertical: spacing.small }}>
                    <View
                        style={{
                            opacity: showNextButton ? 1 : 0,
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Icon size="24px" name={'caretRight'} color={'neutralActionActive'} />
                    </View>
                </TouchableOpacity>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    stepLabel: {
        fontFamily: fontFamily.title,
        fontSize: fontSize.medium2,
    },
    buttonContainer: {
        paddingHorizontal: spacing.medium,
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
    },
    shadowContainer: {
        padding: spacing.small,
        backgroundColor: color.white,
        shadowColor: color.shadow,
        shadowOffset: {
            width: 0,
            height: 8,
        },
        shadowRadius: 10,
        shadowOpacity: 1,
        elevation: 6,
        borderColor: color.shadow,
        borderWidth: 0.2,
    },
})

export default SubmitPage
